import $t from '@Ravnur-Inc/l10n/$t';

import { isOperation } from '@/types/Operation';

export function convertFromError(e: Dictionary<unknown> | unknown): string[] {
  const msg = e instanceof Error ? e.message : null;
  if (isOperation(e) && e.errorReason.length) {
    return e.errorReason;
  }
  const text = msg || $t('common', 'notifications__some_error');
  return [text];
}
